import * as React from "react";

import { Link } from "./Link";
import { CardContact } from "./CardContact";


export const ContactTrigger = (props: any) => {
    return (
        <>
            {props.type == "link" && (
                <Link />
            )}

            {props.type == "card_contact" && (
                <CardContact />
            )}
        </>
    )
}
